const data = [
    {
        title: "Bachelor's Degree of Software Engineering",
        place: "at Kharkiv National University of Radioelectronics",
        date: "2018 - 2023",
        descriptionFirst: "Designed and developed scalable applications using various programming languages and frameworks.",
        descriptionSecond: "Gained a deep understanding of software architecture principles, enabling me to create efficient and maintainable code.",
        descriptionThird: "Honed my teamwork and communication skills through collaborative projects, which prepared me for successful collaboration in real-world software development teams."
    },
    {
        title: "Master's Degree of Software Engineering",
        place: "at Kharkiv National University of Radioelectronics",
        date: "2023 - 2024",
        descriptionFirst: "Delved into advanced topics such as software testing methodologies, software quality assurance, and software security.",
        descriptionSecond: "Explored cutting-edge technologies like machine learning and cloud computing, enabling me to innovate and address complex challenges in the field.",
        descriptionThird: "Contributed to the software engineering community through in-depth investigations and academic publications."
    }
];

export default data;